// Open Sans is the Universal+ brand face. Self-hosted rather than pulled from Google Fonts so the
// app has no third-party request on first paint and renders identically offline.
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { SnackbarProvider } from 'notistack';
import ConfigProvider from '@/context/ConfigProvider';
import AuthenticationProvider from '@/context/AuthenticationProvider';
import ThemeProvider from '@/context/ThemeProvider';
import App from '@/App';

// Provider order matters: config feeds auth (pool ids), and the theme wraps everything that renders,
// including the login screen and snackbars.
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ConfigProvider>
      <ThemeProvider>
        <SnackbarProvider
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          autoHideDuration={4000}
        >
          <AuthenticationProvider>
            <App />
          </AuthenticationProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </ConfigProvider>
  </React.StrictMode>,
);
